import { axiosApiService } from '../axios';

/**
 * Simulation API Service
 */
const SimulationAPIs = {
    /**
     * Get simulation status from backend
     */
    getStatus: async function () {
        try {
            const response = await axiosApiService.get('/simulation/status/');
            return response.data;
        } catch (error) {
            console.error('Error fetching simulation status:', error);
            return { is_simulation: false };
        }
    }
};

export default SimulationAPIs;
